import { Box, Typography, styled, Link } from "@mui/material";
import { useRouter } from "next/router";
import React, { useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../../constants/theme";
import { Context } from "../../../context/context";
import { sendAnalytics } from "../../../utils/analyticsCommon";

const CustomeBrandLogoTile = styled(Box)(({ theme }) => ({
  margin: "32px 0",
  ".grid-container-style": {
    width: "82%",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "16px",
  },
  ".brand-link": {
    textDecoration: "none !important",
    color: "inherit !important",
    display: "block",
    
    "&:hover": {
      textDecoration: "none !important",
      color: "inherit !important",
    },
    
    "&:visited": {
      textDecoration: "none !important",
      color: "inherit !important",
    },
    
    "&:active": {
      textDecoration: "none !important",
      color: "inherit !important",
    },
    
    "&:focus": {
      textDecoration: "none !important",
      color: "inherit !important",
      outline: "none",
    },
    
    "&:link": {
      textDecoration: "none !important",
      color: "inherit !important",
    },
  },
  ".grid-item-style": {
    border: `2px solid ${primary.greyText}`,
    padding: "0px 0px",
    minWidth: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    borderRadius: "4px",
    maxWidth: "160px",
  },
  ".grid-item-style.active": {
    border: `2px solid ${primary.main}`,
  },
  ".logo_img": {
    minHeight: "32px",
    objectFit: "contain",
    maxHeight: "50px",
    minWidth: "86px",
    maxWidth: "16px",
    margin: "auto",
    aspectRatio: "3/4",
  },
  ".allvehiclesText": {
    fontWeight: "700",
    color: primary.greyText,
    minHeight: "32px",
    maxHeight: "50px",
    minWidth: "86px",
    maxWidth: "160px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    margin: "auto",
    aspectRatio: "3/4",
  },
  [theme.breakpoints.down("md")]: {
    ".grid-container-style": {
      width: "100%",
      margin: "auto",
      justifyContent: "center",
      gap: "16px",
    },
    ".grid-item-style": {
      padding: "8px 4px",
      minWidth: "160px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    ".logo_img": {
      minHeight: "32px",
      height: "44.8px",
      maxHeight: "48px",
      minWidth: "70px",
      width: "80px",
      margin: "auto",
    },
  },

  ".content-heading2": {
    fontSize: "24px",
    fontWeight: "600",
    margin: "16px",
    marginLeft: "8%",
  },

  [theme.breakpoints.down("sm")]: {
    ".grid-container-style": {
      width: "100%",
      margin: "auto",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "16px",
    },
    ".grid-item-style": {
      padding: "0",
      minWidth: "100px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    ".logo_img": {
      minHeight: "24px",
      maxHeight: "45px",
      height: "48px",
      minWidth: "60px",
      maxWidth: "70px",
      width: "80px",
      margin: "auto",
      objectFit: "contain",
    },
    ".allvehiclesText": {
      fontSize: "12px",
      minHeight: "24px",
      maxHeight: "45px",
      height: "48px",
      minWidth: "60px",
      maxWidth: "70px",
      width: "80px",
      margin: "auto",
      objectFit: "contain",
    },
    ".content-heading2": {
      fontSize: "24px",
      margin: "16px",
    },
  },
}));

const BrandLogoTile = ({ brand = "", BrandLogos = [], title }) => {
  const navigate = useRouter();
  const state = useContext(Context);
  const { searchQuery } = state;
  // Detect if we're on a Hindi page
  const isHindi = navigate.pathname?.startsWith('/hi/') || navigate.asPath?.startsWith('/hi/');
  const localePrefix = isHindi ? '/hi' : '';

  const getNavigationUrl = (item) => {
    const url = item?.isPassenger
      ? `/electric-commercial-vehicles/${item?.BrandName}`
      : `/electric-commercial-vehicles/${item?.BrandName}`;
    
    // Remove trailing slash if present
    const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
    // Add locale prefix if on Hindi page
    return isHindi ? `${localePrefix}${cleanUrl}` : cleanUrl;
  };

  const handleBrandClick = (e, item) => {
    e.preventDefault();
    const navigationUrl = getNavigationUrl(item);
    
    let payload = {
      brandLogo: item?.BrandName,
    };

    sendAnalytics("sorted_using_brand_logo", payload, "en");
    
    navigate.push(navigationUrl);
    searchQuery("");
  };
  return (
    <CustomeBrandLogoTile>
      {title && (
        <Typography className="content-heading2" varient="h2">
          {title}
        </Typography>
      )}

      <Box className="grid-container-style">
        {BrandLogos?.map((item) => {
          return (
            <Link
              key={item?.id}
              href={getNavigationUrl(item)}
              className="brand-link"
              onClick={(e) => handleBrandClick(e, item)}
            >
              <Box
                item
                xs={2}
                sm={2}
                md={2}
                className={
                  brand?.toLowerCase() === item?.BrandName?.toLocaleLowerCase()
                    ? "grid-item-style active"
                    : "grid-item-style"
                }
              >
                {item?.BrandName === "" ? (
                  <Typography variant="span" className="allvehiclesText">
                    {item?.vehicle_logo}
                  </Typography>
                ) : (
                  <LazyLoadImage
                    src={item?.vehicle_logo}
                    visibleByDefault={true}
                    alt={item?.alt}
                    className="logo_img"
                  />
                )}
              </Box>
            </Link>
          );
        })}
      </Box>
    </CustomeBrandLogoTile>
  );
};

export default BrandLogoTile;
